<template>
  <b-button
    :variant="variant"
    @click="unsubscribe()"
  >
    <svg-icon
      :label="$t('newsletter.unsubscribe')"
      name="r-bell-slash"
      variant="fc-d8"
    />
  </b-button>
</template>

<script>
export default {
  props: {
    email: {
      type: String,
      required: true,
    },
    variant: {
      type: String,
      default: 'light',
    },
  },
  methods: {
    unsubscribe() {
      const form = document.createElement('form');
      const input = [
        document.createElement('input'),
        document.createElement('input'),
      ];
      form.setAttribute('method', 'POST');
      form.setAttribute('action', 'https://contact.framasoft.org/php_list/lists/?p=unsubscribe');

      input[0].setAttribute('type', 'hidden');
      input[0].setAttribute('name', 'email');
      input[0].setAttribute('value', this.email);

      input[1].setAttribute('type', 'hidden');
      input[1].setAttribute('name', 'p');
      input[1].setAttribute('value', 'unsubscribe');

      form.appendChild(input[0]);
      form.appendChild(input[1]);
      document.body.appendChild(form);
      form.submit();
    },
  },
};
</script>
